
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Vendors
import moment from "moment";

// Models
import {AppPlayerTipsRootListIndex} from "@/models/app/player/tips/root/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppPlayerTipsRootListFormLookupIndexVue from "@/views/app/player/tips/root/list/form/lookup.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppPlayerTipsRootListFormLookupIndexVue,
  },
})
export default class AppPlayerTipsRootListIndexVue extends Vue {
  isLoading: boolean | null = false;

  formData: any = {
    filter: {
      user_id: store.getters.getAuthentication.id,
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  moment: any = null;

  tips: Array<AppPlayerTipsRootListIndex> = [];

  async getTips(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/common/tips`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.tips = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    await this.getTips();
  }
}
